import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { EditorFeatureConfigSymbol, PlatformEnvDataProvider } from '@wix/thunderbolt-symbols'
import { name } from './symbols'

export const dsBlocksEnvDataProvider = withDependencies(
	[named(EditorFeatureConfigSymbol, name)],
	(editorConfig: any): PlatformEnvDataProvider => {
		return {
			platformEnvData() {
				return {
					blocks: {
						blocksPreviewData: editorConfig.blocksPreviewData,
					},
				}
			},
		}
	}
)
